export const esMensajeDeMiEmpresa = (mensaje, idUsuario, empid) => {
  const idUsuarioNum = Number(idUsuario)
  const idEmisor = Number(mensaje.idUsuarioEmisor)
  const idComprador = Number(mensaje.idComprador)
  const idVendedor = Number(mensaje.idVendedor)
  const idUsuarioChat = Number(mensaje.idUsuarioChat)
  const tieneIdEmisor = Number.isFinite(idEmisor)

  const esMensajePropioPorParticipantes = () => {
    if (idUsuarioNum === idComprador && idUsuarioChat === idVendedor) return true
    if (idUsuarioNum === idVendedor && idUsuarioChat === idComprador) return true

    return false
  }

  if (tieneIdEmisor && idEmisor === idUsuarioNum) return true
  if (!tieneIdEmisor) return esMensajePropioPorParticipantes()
  if (!empid) return false

  let empidEmisor = null

  if (idEmisor === idComprador) {
    empidEmisor = mensaje.empidComprador
  } else if (idEmisor === idVendedor) {
    empidEmisor = mensaje.empidVendedor
  } else if (idUsuarioChat === idVendedor) {
    empidEmisor = mensaje.empidComprador
  } else if (idUsuarioChat === idComprador) {
    empidEmisor = mensaje.empidVendedor
  }

  return Boolean(empidEmisor) && empidEmisor === empid
}
